<template>
   <div class="contain" :class="getlang">
     <div class="card-header">
       <div class="account-box">
         <div class="img-box" @click="showAccountPicker = true">
           <img :src="logo" class="img-logo">
           <span class="title">
             {{ `${ !accountDetail.account_type ? '--' : accountDetail.account_type &&  accountDetail.account_type == 1 ? $t("transferInto.accountName[0]"):$t("transferInto.accountName[1]")}\n&nbsp;(${ accountDetail.account_no ? accountDetail.account_no : ''  })`}}
           </span>
           <img :src="bgColor == 'black-theme' ? darkDown : arrowDown " class="icon-arrow" />
         </div>
         <div class="hkd-sum">
            <div class="title">
              {{ $t("withdraw.transferred_total_text") }}
              <span class="unit">
                {{ accountDetail.base_currency || '(HKD)' }}
              </span>
            </div>
            <div class="amount">
              {{ getAmount(accountDetail.base_can_draw) }}
            </div>
         </div>
         <div class="curreny-box">
           <div class="left">
             <div class="top">{{ $t("withdraw.usd") }}</div>
             <div class="bottom">{{ getAmount(accountDetail.usd_can_draw) }}</div>
           </div>
           <div class="center">
             <div class="top">{{ $t("withdraw.hkd") }}</div>
             <div class="bottom">{{ getAmount(accountDetail.hkd_can_draw) }}</div>
           </div>
           <div class="right">
             <div class="top">{{ $t("withdraw.rmb") }}</div>
             <div class="bottom">{{ getAmount(accountDetail.cnh_can_draw) }}</div>
           </div>
         </div>
       </div>
     </div>

     <!--  银行卡列表   -->
     <div class="select-box">
       <div class="ipt-box" :class="{error: !withdrawForm.remittance_bank_id && errorStatus}">
         <div class="ipt-main" @click="bankPicker = true">
           <div class="val-box">
            <span class="label" :class="{ placeholder: !withdrawForm.remittance_bank_id }"
            >{{ $t("withdrawNew.lang2") }}</span
            >
             <span class="val" v-if="withdrawForm.remittance_bank_id">{{ getSelectText(2,1) }}</span>
           </div>
           <span class="icon-arrow"></span>
         </div>
         <p class="error">{{ $t('withdrawNew.lang3') }}</p>
       </div>
       <div class="tip-text">{{ $t('withdrawNew.lang14') }}</div>
       <van-popup v-model="bankPicker" position="bottom" class="picker-ui">
         <van-picker
           :columns="getInitList(2)"
           show-toolbar
           @cancel="bankPicker = false"
           :default-index="getSelectText(2,2)"
           @confirm="onBankConfirm"
         />
       </van-popup>
     </div>

     <div class="select-box">
       <div class="ipt-box" :class="{error: !withdrawForm.remittance_currency && errorStatus}">
         <div class="ipt-main" @click="currencyPicker = true">
           <div class="val-box">
            <span class="label" :class="{ placeholder: !withdrawForm.remittance_currency }"
            >{{ $t("withdrawNew.lang0") }}</span
            >
             <span class="val" v-if="withdrawForm.remittance_currency">{{ getSelectText(1,1) }}</span>
           </div>
           <span class="icon-arrow"></span>
         </div>
         <p class="error">{{ $t('withdrawNew.lang1') }}</p> 
       </div>
       <van-popup v-model="currencyPicker" position="bottom" class="picker-ui">
         <van-picker
           :columns="getInitList(1)"
           show-toolbar
           @cancel="currencyPicker = false"
           :default-index="getSelectText(1,2)"
           @confirm="onCurrencyConfirm"
         />
       </van-popup>
     </div>
    
     <div class="select-box">
       <div :class="{'focus':inputFocusId == 1,error: errorStatus && !withdrawForm.amount}" class="ipt-box">
         <div class="ipt-main">
           <div class="val-box">
             <span v-if="inputFocusId == 1 || withdrawForm.amount" class="label">{{ $t("withdrawNew.lang4") }}</span>
             <div style="display: flex" class="amount-dom">
               <van-field
                 :placeholder="inputFocusId == 1 ? '' : $t('withdrawNew.lang4')"
                 class="val"
                 ref="amountField"
                 :value="displayAmount"
                 @blur="handError(withdrawForm.amount)"
                 @focus="inputFocus(1)"
                 @input="handValidateInput"
                 :readonly="amountIsAll"
               ></van-field>
               <Icon name="clear" color="#C8C9CC" v-if="amountIsAll" @click="handClear" class="all-icon" />
             </div>

           </div>
         </div>
         <p v-if="!withdrawForm.amount && errorStatus" class="error">{{ $t("withdrawNew.lang5") }}</p>
       </div>
     </div>
     <div class="tag-btn" @click="setAmountIsAll" v-if="isShowAllAmount" :class="{'tag-btn-active':isShowAllactive}">{{ $t('withdrawNew.lang6') }}</div>


     <div class="foot-pancel">
       <nav-buttons
         :isFixed="false"
         :showPrev="false"
         :disabled="getBtnDisable"
         :nextText="$t('investmentExperience.lang7')"
         @on-next="handSubmit"
       />
     </div>


     <div class="foot-tip">
       <div class="tip-title">
         {{ $t("withdrawNew.tips[0]") }}
       </div>
       <div class="tip-content">
         {{ $t("withdrawNew.tips[1]") }}
       </div>
       <div class="tip-content">
         {{ $t("withdrawNew.tips[2]") }}
       </div>
     </div>
     <ActionSheet
       :title="$t('withdrawNew.lang')"
       v-model="showAccountPicker"
       class="action-sheet-sex"
     >
       <div>
         <div class="sheet-box" v-for="(item,index) in accountList" :key="item.account_no" @click="selectAccount(item,index)" :class="{getlang,'active-border':index == activeSelect}">
           <div class="img-box">
             <img :src="item.account_type == 1 ? future : security" class="img-logo" />
             <span class="title">
              {{ `${ item.account_type == 1 ? $t("transferInto.accountName[0]"):$t("transferInto.accountName[1]")}\n&nbsp;(${ item.account_no })`}}
             </span>
           </div>
           <div class="icon-box">
             <Icon :name="rightOK" class="success-icon" size="22" v-if="index == activeSelect" color="#EA3447"  />
           </div>
         </div>
       </div>
     </ActionSheet>

     <van-dialog v-model="showVerifyPasswordDialog"
                 class="check-password-dialog"
                 :title="$t('fail_reason.checkPassword')" show-cancel-button
                 :before-close="handleBeforeClose">
       <div class="verifyLoginPassword">
         <Field class="input" v-model="checkPassword" :type="eyeIsOpen ? 'text' : 'password'" >
           <template #button>
             <img
               src="@/assets/images/app-pages/light_close.png"
               class="eye lightClose"
               v-show="!eyeIsOpen"
               @click="eyeSwitch"
             >
             <img
               src="@/assets/images/app-pages/dark_close.png"
               class="eye darkClose"
               v-show="!eyeIsOpen"
               @click="eyeSwitch"
             >
             <img
               src="@/assets/images/app-pages/light_open.png"
               class="eye lightOpen"
               v-show="eyeIsOpen"
               @click="eyeSwitch"
             >
             <img
               src="@/assets/images/app-pages/dark_open.png"
               class="eye darkOpen"
               v-show="eyeIsOpen"
               @click="eyeSwitch"
             >
           </template>
         </Field>
       </div>
     </van-dialog>
    <!--     密码错误  -->
     <password-error-prompt
       v-show="pwdErrPromptOption.show"
       :err-code="pwdErrPromptOption.errCode"
       :err-html="pwdErrPromptOption.errHtml"
       @password-error-prompt-confirm="passwordErrorPromptConfirm"
       ref="password-error-prompt-el"
     ></password-error-prompt>


     <van-dialog
       v-model="isShowOpenDialog"
       :show-confirm-button="false"
       :showCancelButton="false"
       class="m-open-dialog"
     >
       <div class="dialog-main">
         <div class="dialog-title">
           <img src="../../../assets/images/open-account/tip_icon.png" class="img-dia" />
         </div>
         <p class="text">{{ $t("withdrawNew.lang8") }}</p>
         <p class="email"
         >{{ $t("withdrawNew.lang9") }}</p>
         <div class="foot-dia-btn">
           <div class="dia-btn" @click="handNext">{{ $t("transferInto.lang8") }}</div>
         </div>
       </div>
     </van-dialog>

     <van-dialog
       v-model="bankDialogShow"
       :show-confirm-button="false"
       :showCancelButton="false"
       class="bank-open-dialog"
     >
       <div class="dialog-main">
         <div class="dialog-title">
           {{ $t('personalInformation.error_tip.lang9') }}
         </div>
         <p class="text">{{ $t("withdrawNew.lang10") }}</p>
         <p class="email"
         >{{ $t("withdrawNew.lang11") }}</p>
         <div class="foot-dia-btn">
            <div class="left-btn" @click="bankDialogShow = false">{{ $t("withdrawNew.lang12") }}</div>
            <div class="right-btn" @click="handBingBank">{{ $t("withdrawNew.lang13") }}</div>
         </div>
       </div>
     </van-dialog>
   </div>
</template>

<script>
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import { localeString,validateInput } from '@/utils/utils.new'
import { ActionSheet, Icon, Popup as VanPopup, Picker as VanPicker, Field as VanField, Dialog, Field, Toast } from "vant";
import arrowDown from '@/assets/images/arrow-down.png'
import darkDown from '@/assets/images/open-account/dark_icon.png'
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import { getBrowser } from "@/utils/browser";
import { closeWebView } from "@/utils/hybirdMethods";
import navButtons from '../components/navButtons.vue'
import rightOK from '@/assets/images/app-pages/right_ok.png'

export default {
  components: { passwordErrorPrompt, Field, ActionSheet,Icon,VanPopup,VanPicker,VanField,[Dialog.Component.name]: Dialog.Component,navButtons },
  data() {
    return {
      future,
      security,
      arrowDown,
      darkDown,
      rightOK,
      accountList:[],
      logo:null,
      accountDetail: {},
      showAccountPicker:false,
      activeSelect:-1,
      withdrawForm:{
        remittance_currency:'',
        remittance_bank_id:'',
        amount:''
      },
      errorStatus:false,
      currencyPicker:false,
      bankCardList:[],
      bankPicker:false,
      inputFocusId:null,
      amountIsAll:false,
      showVerifyPasswordDialog: false,
      checkPassword:'',
      eyeIsOpen: false,  // 是否明文显示密码
      pwdErrPromptOption: {
        show: false,
        errCode: -1,
        errHtml: ""
      },
      isShowOpenDialog:false,
      bankDialogShow:false,
      isShowAllactive:false
    };
  },
  created() {
    this.init()

    // this.$nextTick(() =>{
    // })
  },
  computed:{
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getlang(){
      return localStorage.getItem('localLang')
    },
    getBtnDisable() {
      let btnDis = false;
      const remittance_bank_id = this.withdrawForm.remittance_bank_id;
      const amount = this.withdrawForm.amount;
      const remittance_currency = this.withdrawForm.remittance_currency;
      if (!remittance_bank_id || !amount || !remittance_currency) {
        btnDis = true;
      }
      return btnDis;
    },
    isShowAllAmount(){
      const { base_currency,usd_can_draw,hkd_can_draw,cnh_can_draw } = this.accountDetail;
      const balanceMap = {
        'USD': usd_can_draw,
        'HKD': hkd_can_draw,
        'CNH': cnh_can_draw,
      };
      const balance = parseFloat(balanceMap[base_currency]);
      return balance > 0;
    },
    displayAmount(){
      return this.amountIsAll ? this.$t('withdrawNew.lang6') : this.withdrawForm.amount;
    }
  },
  methods:{
    async init(){
      this.logo = this.$route.query.account_type == 1 ? future : security
      try {
        await this.$apis.getBankList().then(res =>{
          if(res){
            res.forEach(item =>{
              const bankCodeText = item.bank_code ? `${item.bank_code} ` : ''
              this.bankCardList.push({
                text:`${bankCodeText}${item.bank_name}(${item.secret_card})`,
                value:item.id,
                bank_code: item.bank_code,
                currency_type: item.currency_type
              })
            })
          }
        })
        if(this.bankCardList.length == 0){
          this.bankDialogShow = true
        }
        // eslint-disable-next-line no-empty
      } catch (e){

      }
      this.getAccountList();
    },
    getInitList(e){
      const key = {
        1: this.$t("transferInto.lang2.colums"),
        2: this.bankCardList
      }
      if(e === 1){
        const list = key[1] || [];
        const bankId = this.withdrawForm.remittance_bank_id;
        const bankList = this.bankCardList || [];
        const currencyMap = {};
        const pushCurrency = function(str){
          if(!str){
            return
          }
          str.split(',').map(function(s){
            return (s || '').trim();
          }).filter(function(s){
            return s;
          }).forEach(function(c){
            currencyMap[c] = 1;
          });
        };
        // 未选银行卡：展示所有银行卡支持币种（去重后）与币种列表的交集
        if(!bankId){
          bankList.forEach(function(item){
            pushCurrency(item && item.currency_type);
          });
        }else{
          const curBank = bankList.find(function(item){
            return String(item.value) === String(bankId);
          }) || {};
          pushCurrency(curBank.currency_type);
        }
        const currencyList = Object.keys(currencyMap);
        if(currencyList.length === 0){
          return list
        }
        return list.filter(function(item){
          return currencyMap[item.value] === 1;
        });
      }
      return key[e]
    },
    getAccountList() {
      this.$apis.getAuthList().then(res => {
        if(res){
          const { accountInfo } = res
          this.accountList = accountInfo || []
          this.accountDetail = accountInfo.find(item => item.account_no == this.$route.query.account_no) || {}
          this.$nextTick(() =>{
            this.activeSelect = this.accountList.findIndex(item => item.account_no == this.$route.query.account_no)
          })
        }
      });
    },
   // 千分位转换
    getAmount(num){
      return localeString(num)
    },
    selectAccount(e,i){
      this.activeSelect = i
      this.logo = e.account_type == 1 ? future : security
      this.accountDetail = this.accountList.find(item => item.account_no == e.account_no)
      this.showAccountPicker = false
    },
    getSelectText(type,i){
      const valueList = this.getInitList(type)
      if(valueList && valueList.length > 0){
        if(i == 1){
          if(type == 1 && this.withdrawForm.remittance_currency){
            this.accountDetail.base_currency = valueList.find(item => item.value == this.withdrawForm.remittance_currency).value
            return valueList.find(item => item.value == this.withdrawForm.remittance_currency).text
          }
          if(type == 2 && this.withdrawForm.remittance_bank_id){
            return valueList.find(item => item.value == this.withdrawForm.remittance_bank_id).text
          }
        }else{
          if(type == 1 && this.withdrawForm.remittance_currency){
            return valueList.findIndex(item => item.value == this.withdrawForm.remittance_currency)
          }
          if(type == 2 && this.withdrawForm.remittance_bank_id){
            return valueList.findIndex(item => item.value == this.withdrawForm.remittance_bank_id)
          }
        }
      }
    },
    onCurrencyConfirm(e){
      this.currencyPicker = false;
      this.withdrawForm.remittance_currency = e.value;
    },
    onBankConfirm(e){
      this.bankPicker = false;
      const nextBankId = e && e.value;
      const curBankId = this.withdrawForm.remittance_bank_id;
      const curCurrency = this.withdrawForm.remittance_currency;
      // 切换银行卡：若新卡仍支持当前已选币种则保留，否则清空，避免币种不匹配提交
      if(curCurrency && String(curBankId) !== String(nextBankId)){
        const bankItem = (this.bankCardList || []).find(function(item){
          return String(item.value) === String(nextBankId);
        }) || {};
        const currencyArr = (bankItem.currency_type || '').split(',').map(function(s){
          return (s || '').trim();
        }).filter(function(s){
          return s;
        });
        if(currencyArr.indexOf(curCurrency) === -1){
          this.withdrawForm.remittance_currency = '';
        }
      }
      this.withdrawForm.remittance_bank_id = nextBankId;
    },
    handError(e) {
      this.errorStatus = false;
      if (!e) {
        this.errorStatus = true;
      }
    },
    inputFocus(id){
      this.inputFocusId = id
    },
    handValidateInput(value){
     this.withdrawForm.amount = validateInput(value);
      this.$nextTick(() => {
        this.$refs.amountField.$el.querySelector('input').value = validateInput(value);
      });
    },
    // 全部金额
    setAmountIsAll(){
      this.amountIsAll = !this.amountIsAll;
      this.isShowAllactive = !this.isShowAllactive
      if (this.amountIsAll) {
        const { base_currency,usd_can_draw,hkd_can_draw,cnh_can_draw } = this.accountDetail;
        const balanceMap = {
          'USD': usd_can_draw,
          'HKD': hkd_can_draw,
          'CNH': cnh_can_draw,
        };
        const balance = parseFloat(balanceMap[base_currency]);
        this.withdrawForm.amount = balance
      } else {
        this.withdrawForm.amount = ''
      }
    },
    handSubmit(){
      if(this.getBtnDisable){
        this.errorStatus = true
        return
      }
      this.showVerifyPasswordDialog = true
    },
    handleBeforeClose(action, done) {
      // 取消直接关闭弹窗
      if ( action != 'confirm' ) {
        this.showVerifyPasswordDialog = false;
        done()
        return false;
      }
      // 确认带上done，作用是控制弹窗是否关闭 done(false)不允许关闭
      this.confirm(done);
    },
    eyeSwitch() {
      this.eyeIsOpen = !this.eyeIsOpen;
    },
    passwordErrorPromptConfirm(errCode) {
      this.pwdErrPromptOption.show = false;
      if (errCode === 100173) {
        this.showVerifyPasswordDialog = true;
        this.$refs["custom-field-password"].setInputFocus();
        setTimeout(() => {
          this.$refs["custom-field-password"].setInputFocus();
        }, 500);
      }
    },
    confirm(done) {
      if (this.checkPassword === "") {
        Toast(this.$t("fail_reason.checkPasswordTips"));
        done(false)
      } else {
        this.$apis.checkPasswordFail({ password: this.checkPassword }).then((res) => {
          done(false)
          const toastLoading = Toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: "spinner",
            message: this.$t("common.loading_text")
          });
          if (res.code) {
            if (res.code === 100174 || res.code === 100173) {
              this.pwdErrPromptOption.errCode = res.code;
              this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
              this.pwdErrPromptOption.show = true;
              this.$refs["password-error-prompt-el"].show = true;
              done(false)
              toastLoading.clear()
              return
            }
          } else {
            const params = {
              ...this.withdrawForm,
              funds_account_type:this.accountDetail.account_type,
              account_no:this.accountDetail.account_no,
              is_all: this.amountIsAll ? 1 : 0
            };
            if(this.amountIsAll){
              params.amount = 0;
            }

            this.$apis.postWithdrawOrder(params).then(() => {
              this.isShowOpenDialog = true
              toastLoading.clear()
            })
              .catch(e => {
                
              });
          }
        });
      }
    },
    handNext(){
      this.isShowOpenDialog = false
      const browser = getBrowser()
      const isAPP = browser.isApp;
      if(isAPP){
        closeWebView()
      }else{
        this.$router.push({ path: "/app-pages/bankTransfer",query:{account_no:this.accountDetail.account_no,account_type:this.accountDetail.account_type} });
      }
    },
    handBingBank(){
      this.$router.push({ path: "/bank-card-add" });
    },
    handClear(){
      this.withdrawForm.amount = ''
      this.amountIsAll = !this.amountIsAll;
      this.isShowAllactive = !this.isShowAllactive
    }
  }

};
</script>

<style scoped lang="less">
@import '../styles/styles.less';

.contain {
  padding: 20px 32px;
  .select-box{
    margin: 20px 0px;
  }
  .tip-text{
    text-align: right;
    font-size: 24px;
    font-weight: 400;
    color: #f24e1e;
    line-height: 26px;
    width: 100%;
  }
  .bank-open-dialog{
    .dialog-main{
      .dialog-title{
        text-align: center;
        padding-top: 56px;
        font-size: 36px;
        font-weight: 600;
        color: #17161c;
      }
      .text{
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        color: #747377;
        padding-top: 32px;
      }
      .email{
        font-size: 28px;
        font-weight: 400;
        text-align: center;
        color: #f24e1e;
        line-height: 32px;
        padding-top: 16px;
      }
      .foot-dia-btn{
        display: flex;
        margin: 48px 56px;
        align-items: center;
        justify-content: center;
        .left-btn{
          height: 104px;
          background: rgba(15,15,47,0.04);
          border-radius: 200px;
          line-height: 104px;
          font-size: 28px;
          font-weight: 500;
          color: #17161c;
          width: 232px;
          text-align: center;
        }
        .right-btn{
          height: 104px;
          background: #17161C;
          border-radius: 200px;
          line-height: 104px;
          font-size: 28px;
          font-weight: 500;
          color: #FFFFFF;
          width: 232px;
          text-align: center;
          margin-left: 24px;
        }
      }
    }
  }
  .foot-pancel{
    margin-top: 54px;
  }
}
.black-theme{
  .ipt-box{
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,1);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff !important;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
  .bank-open-dialog{
    background: #1B1C24;
    .dialog-main{
      .dialog-title{
        color: #FFFFFF;
      }
      .text{
        color: #9D9D9F;
      }
    }
    .foot-dia-btn{
      .left-btn{
        background: #8E92A3 !important;
        color: #FFFFFF !important;
      }
      .right-btn{
        background-color: #377CFB !important;
      }
    }
  }
}
.amount-dom{
  display: flex;
}
/deep/ .van-cell::after{
  border-bottom: 0;
}
.all-icon{
  padding-top: 2px;
}


</style>
